import React, { useCallback, useState, useRef, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";

import ConsecutiveSnackbarMessages from "../../shared/components/ConsecutiveSnackbarMessages";
import Cookies from "js-cookie";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import AOS from "aos/dist/aos";
import { withStyles } from "@mui/styles";
import NavBar from "./navigation/NavBar";
import "aos/dist/aos.css";
import CookieRulesDialog from "./cookies/CookieRulesDialog";
import CookieConsent from "./cookies/CookieConsent";
import DialogSelector from "./register_login/DialogSelector";
import Routing from "./Routing";
import {
  addContacto,
  addLead /* 
  getBusqueda,
  getCapitulos,
  getSecciones,
  getFraccion,
  getPartida,
  getSubpartida,
  getNicos, */,
} from "./../../actions/landingActions";
import messages_es from "../../localization/texto_es.json";
import messages_en from "../../localization/texto_en.json";

AOS.init({ once: true });

const styles = (theme) => ({
  wrapper: {},
});

function Main(props) {
  const {
    classes,
    errors,
    addContacto,
    landing,
    addLead /* 
    getBusqueda,
    getCapitulos,
    getSecciones,
    getFraccion,
    getPartida,
    getSubpartida,
    getNicos, */,
  } = props;

  const [selectedTab, setSelectedTab] = useState(null);
  const [isCookieRulesDialogOpen, setIsCookieRulesDialogOpen] = useState(false);
  const [isMobileDrawerOpen, setIsMobileDrawerOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(null);
  const [pushMessageToSnackbar, setPushMessageToSnackbar] = useState(null);
  const [idioma, setIdioma] = React.useState("es-MX");

  const messages = idioma === "es-MX" ? messages_es : messages_en;

  const quienes = useRef();
  const servicios = useRef();
  const inicio = useRef();
  const faqs = useRef();
  const anuncios = useRef();

  useEffect(() => {
    if (
      Cookies.get("idioma") &&
      (Cookies.get("idioma") === "es-MX" || Cookies.get("idioma") === "en-US")
    ) {
      setIdioma(Cookies.get("idioma"));
    }

    if (!Cookies.get("session_token")) {
      const uniqueId = uuidv4();

      Cookies.set("session_token", uniqueId);
    }
  }, []);

  function handleScrollClick(element) {
    element.current.scrollIntoView({ block: "nearest", behavior: "smooth" });

    var headerOffset = 72;
    var elementPosition = element.current.getBoundingClientRect().top;
    var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition < 150 ? 0 : offsetPosition,
      behavior: "smooth",
    });
  }

  const handleCookieRulesDialogOpen = useCallback(() => {
    setIsCookieRulesDialogOpen(true);
  }, [setIsCookieRulesDialogOpen]);

  const handleCookieRulesDialogClose = useCallback(() => {
    setIsCookieRulesDialogOpen(false);
  }, [setIsCookieRulesDialogOpen]);

  const selectHome = useCallback(() => {
    window.scrollTo(0, 0);
    document.title = "Tarifa empresarial | IMAR sistemas";
    setSelectedTab("Home");
  }, [setSelectedTab]);

  const openLoginDialog = useCallback(() => {
    setDialogOpen("login");
    setIsMobileDrawerOpen(false);
  }, [setDialogOpen, setIsMobileDrawerOpen]);

  const closeDialog = useCallback(() => {
    setDialogOpen(null);
  }, [setDialogOpen]);

  const openRegisterDialog = useCallback(() => {
    setDialogOpen("register");
    setIsMobileDrawerOpen(false);
  }, [setDialogOpen, setIsMobileDrawerOpen]);

  const openTermsDialog = useCallback(() => {
    setDialogOpen("termsOfService");
  }, [setDialogOpen]);

  const openContactoDialog = useCallback(() => {
    setDialogOpen("contacto");
  }, [pushMessageToSnackbar, setDialogOpen]);

  const handleMobileDrawerOpen = useCallback(() => {
    setIsMobileDrawerOpen(true);
  }, [setIsMobileDrawerOpen]);

  const handleMobileDrawerClose = useCallback(() => {
    setIsMobileDrawerOpen(false);
  }, [setIsMobileDrawerOpen]);

  const getPushMessageFromChild = useCallback(
    (pushMessage) => {
      setPushMessageToSnackbar(() => pushMessage);
    },
    [setPushMessageToSnackbar]
  );

  return (
    <div className={classes.wrapper}>
      {!isCookieRulesDialogOpen && (
        <CookieConsent
          handleCookieRulesDialogOpen={handleCookieRulesDialogOpen}
        />
      )}
      <CookieRulesDialog
        open={isCookieRulesDialogOpen}
        onClose={handleCookieRulesDialogClose}
      />

      <ConsecutiveSnackbarMessages
        getPushMessageFromChild={getPushMessageFromChild}
      />

      <DialogSelector
        dialogOpen={dialogOpen}
        onClose={closeDialog}
        openTermsDialog={openTermsDialog}
        openContactoDialog={openContactoDialog}
        addContacto={addContacto}
        errors={errors}
        landing={landing}
        pushMessageToSnackbar={pushMessageToSnackbar}
        messages={messages}
      />

      <NavBar
        selectedTab={selectedTab}
        selectTab={setSelectedTab}
        openLoginDialog={openLoginDialog}
        openRegisterDialog={openRegisterDialog}
        openContactoDialog={openContactoDialog}
        mobileDrawerOpen={isMobileDrawerOpen}
        handleMobileDrawerOpen={handleMobileDrawerOpen}
        handleMobileDrawerClose={handleMobileDrawerClose}
        handleScrollClick={handleScrollClick}
        servicios={servicios}
        quienes={quienes}
        inicio={inicio}
        anuncios={anuncios}
        setIdioma={setIdioma}
        idioma={idioma}
        messages={messages}
      />

      <Routing
        selectHome={selectHome}
        landing={landing}
        errors={errors}
        addLead={addLead}
        quienes={quienes}
        inicio={inicio}
        /*         getBusqueda={getBusqueda}
        getCapitulos={getCapitulos}
        getSecciones={getSecciones}
        getNicos={getNicos} */
        faqs={faqs}
        anuncios={anuncios}
        servicios={servicios}
        openTermsDialog={openTermsDialog}
        pushMessageToSnackbar={pushMessageToSnackbar}
        handleScrollClick={handleScrollClick}
        idioma={idioma}
        messages={messages}
        /* getPartida={getPartida}
        getSubpartida={getSubpartida}
        getFraccion={getFraccion} */
      />
    </div>
  );
}

Main.propTypes = {
  addContacto: PropTypes.func.isRequired,
  /* getBusqueda: PropTypes.func.isRequired,
  getCapitulos: PropTypes.func.isRequired,
  getSecciones: PropTypes.func.isRequired,
  getFraccion: PropTypes.func.isRequired,
  getSubpartida: PropTypes.func.isRequired,
  getPartida: PropTypes.func.isRequired, */
  addLead: PropTypes.func.isRequired,
  landing: PropTypes.object.isRequired,
  errors:
    PropTypes.object.isRequired /* 
  getNicos: PropTypes.func.isRequired, */,
};

const mapStateToProps = (state) => ({
  landing: state.landing,
  errors: state.errors,
});

export default withStyles(styles, { withTheme: true })(
  connect(mapStateToProps, {
    addContacto,
    addLead,
    /*     getBusqueda,
    getCapitulos,
    getSecciones,
    getNicos,
    getFraccion,
    getPartida,
    getSubpartida, */
  })(Main)
);
